import { toast } from "react-toastify";
import firebase from "../firebase";
import { GET_FUTURE_MESSAGES } from "./types";
import { v4 as uuidv4 } from "uuid";
import { customAlert } from "./alertActions";

export const setLoading = (val) => async (dispatch) => {
  dispatch({
    type: "FUTURE_MESSAGE_LOADING",
    payload: val,
  });
};

export const getFutureMessages = (uid) => {
  return (dispatch) => {
    firebase
      .firestore()
      .collection("future_messages")

      .where("sender_id", "==", uid)
      .orderBy("created_at", "asc")
      .onSnapshot((query) => {
        var tempFutureMessages = [];
        query.forEach((doc) => {
          tempFutureMessages.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: GET_FUTURE_MESSAGES,
          payload: tempFutureMessages,
        });
      });
  };
};

export const getSingleMessage = (id) => async (dispatch) => {
  var singleMessage = await firebase
    .firestore()
    .collection("future_messages")
    .doc(id)
    .get();
  if (singleMessage) {
    dispatch({ type: "GET_SINGLE_MESSAGE", payload: singleMessage.data() });
  }
};

export const createFutureMessage = (obj) => async (dispatch) => {
  dispatch(setLoading(true));
  let media_data = {};
  let imagesUrl = [];
  let images = null;
  if (obj.media.length > 0) {
    images = obj.media;
    for (var i = 0; i < images.length; i++) {
      let filename = images[i].name;
      let ext2 = filename.slice(filename.lastIndexOf("."));
      let file_name = uuidv4() + ext2.toLowerCase();
      let storageRef = await firebase
        .storage()
        .ref("future_messages_images/" + file_name)
        .put(images[i]);
      let url = await storageRef.ref.getDownloadURL();
      imagesUrl.push(url);
    }
    media_data = {
      media: imagesUrl,
    };
  } else {
    media_data = {
      media: null,
    };
  }
  let newObj = {
    title: obj.title,
    media_files: media_data.media,
    message: obj.message,
    send_to: obj.send_to,
    email: obj.email,
    sms: obj.sms,
    deliveryDate: obj.deliveryDate,
    deliveryTime: obj.deliveryTime,
    sender_id: obj.sender_id,
    created_at: firebase.firestore.Timestamp.now(),
    deliver_at: firebase.firestore.Timestamp.fromDate(
      new Date(`${obj.deliveryDate} ${obj.deliveryTime}:0`)
    ),
  };
  firebase
    .firestore()
    .collection("future_messages")
    .add(newObj)
    .then((res) => {
      dispatch(customAlert(true, "Future Message Added Successfully"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.success("Future Message Added Successfully")
      dispatch(setLoading(false));
      return;
    })
    .catch((err) => {
      dispatch(customAlert(true, err.message));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.warning(err.message)
      dispatch(setLoading(false));
    });
};

export const updateFutureMessage =
  (id, obj, onComplete = () => {}) =>
  async (dispatch) => {
    dispatch(setLoading(true));
    let media_data = {};
    let imagesUrl = [];
    let images = null;
    if (obj.media != null) {
      images = obj.media;
      for (var i = 0; i < images.length; i++) {
        let filename = images[i].name;
        let ext2 = filename.slice(filename.lastIndexOf("."));
        let file_name = uuidv4() + ext2.toLowerCase();
        let storageRef = await firebase
          .storage()
          .ref("future_messages_images/" + file_name)
          .put(images[i]);
        let url = await storageRef.ref.getDownloadURL();
        imagesUrl.push(url);
      }
      media_data = {
        media: imagesUrl,
      };
    }
    let newObj;
    if (obj.media != null) {
      newObj = {
        title: obj.title,
        // media_files: media_data.media,
        message: obj.message,
        send_to: obj.send_to,
        email: obj.email,
        sms: obj.sms,
        deliveryDate: obj.deliveryDate,
        deliveryTime: obj.deliveryTime,
        deliver_at: firebase.firestore.Timestamp.fromDate(
          new Date(`${obj.deliveryDate} ${obj.deliveryTime}:0`)
        ),
      };
      firebase
        .firestore()
        .collection("future_messages")
        .doc(id)
        .update(newObj)
        .then((res) => {
          dispatch(customAlert(true, "Future Message Updated Successfully"));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // toast.success('Future Message Updated Successfully');
          dispatch(setLoading(false));
          onComplete();

          return;
        })
        .catch((err) => {
          dispatch(customAlert(true, err.message));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // toast.warning(err.message);
          dispatch(setLoading(false));
        });
      media_data.media.map((media) => {
        return firebase
          .firestore()
          .collection("future_messages")
          .doc(id)
          .update({
            media_files: firebase.firestore.FieldValue.arrayUnion(media),
          });
      });
    } else {
      newObj = {
        title: obj.title,
        message: obj.message,
        send_to: obj.send_to,
        email: obj.email,
        sms: obj.sms,
        deliveryDate: obj.deliveryDate,
        deliveryTime: obj.deliveryTime,
      };
      firebase
        .firestore()
        .collection("future_messages")
        .doc(id)
        .update(newObj)
        .then((res) => {
          // toast.success('Future Message Updated Successfully');
          dispatch(customAlert(true, "Future Message Updated Successfully"));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          dispatch(setLoading(false));
          onComplete();
          return;
        })
        .catch((err) => {
          // toast.warning(err.message);
          dispatch(customAlert(true, err.message));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          dispatch(setLoading(false));
        });
    }
  };

export const deleteFutureMessage = (id, media_files) => async (dispatch) => {
  if (media_files?.length > 0) {
    media_files.map(async (media) => {
      await firebase.storage().refFromURL(media).delete();
    });
  }
  firebase
    .firestore()
    .collection("future_messages")
    .doc(id)
    .set({ status: "deleted" })
    .then((res) => {
      dispatch(customAlert(true, "Future message deleted successfully"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.success('Future message deleted successfully');
    });
};

export const deleteSingleMediaFile = (id, url) => async (dispatch) => {
  await firebase.storage().refFromURL(url).delete();
  await firebase
    .firestore()
    .collection("future_messages")
    .doc(id)
    .update({
      media_files: firebase.firestore.FieldValue.arrayRemove(url),
    });
};
